document.addEventListener("DOMContentLoaded", function () {
  const tagOrder = [
    "bb-500g-o", "bb-500g-v", "bb-40g-o", "bb-40g-v",
    "bb-protein", "bb-latte", "bb-bar", "bb-frappe", "bb-acc"
  ];

  function getTagIndex(tag) {
    const index = tagOrder.indexOf(tag);
    return index === -1 ? 1000 : index;
  }

  const tagList = document.querySelector(".tag-list");
  const tagItems = Array.from(tagList.children);
  tagItems.sort((a, b) => {
    const aIndex = getTagIndex(a.getAttribute("data-tag"));
    const bIndex = getTagIndex(b.getAttribute("data-tag"));
    return aIndex - bIndex || a.getAttribute("data-tag").localeCompare(b.getAttribute("data-tag"));
  });

  tagItems.forEach(item => tagList.appendChild(item));

  tagItems.forEach(item => {
    const tagText = item.getAttribute("data-tag");
    const prodTagDiv = item.querySelector('.prod-tag');

    if (prodTagDiv) {
      switch (tagText) {
        case "bb-acc": prodTagDiv.innerText = "Accessories"; break;
        case "bb-500g-o": prodTagDiv.innerText = "Original Large Bags"; break;
        case "bb-40g-o": prodTagDiv.innerText = "Original Sachets"; break;
        case "bb-latte": prodTagDiv.innerText = "Super Lattes"; break;
        case "bb-protein": prodTagDiv.innerText = "Plain Proteins"; break;
        case "bb-frappe": prodTagDiv.innerText = "Super Nut Frappés"; break;
        case "bb-bar": prodTagDiv.innerText = "KetoTHIS Meal Bars"; break;
        case "bb-500g-v": prodTagDiv.innerText = "Vegan Large Bags"; break;
        case "bb-40g-v": prodTagDiv.innerText = "Vegan Sachets"; break;
        default: break;
      }
    }
  });

  function updateQuantityIndicatorForTag(tag) {
    const productItems = document.querySelectorAll(`.product-item[data-tags*='${tag}']`);
    let totalQuantity = 0;

    productItems.forEach(function (product) {
      const quantityInput = product.querySelector('input[name="quantity"]');
      const quantity = parseInt(quantityInput.value) || 0;
      totalQuantity += quantity;
    });

    const qtyIndDiv = document.querySelector(`.bb-tag-item[data-tag='${tag}'] .qty-ind`);
    if (qtyIndDiv) {
      qtyIndDiv.innerText = totalQuantity;
      qtyIndDiv.style.visibility = totalQuantity > 0 ? 'visible' : 'hidden';
    }
  }

  function updateAllQuantityIndicators() {
    const allTags = document.querySelectorAll(".bb-tag-item[data-tag]");
    allTags.forEach(tagItem => {
      const tag = tagItem.getAttribute("data-tag");
      updateQuantityIndicatorForTag(tag);
    });
  }

  function adjustQuantity(element, isIncrement) {
    const quantityInput = element.parentElement.querySelector('input[name="quantity"]');
    let quantity = parseInt(quantityInput.value) || 0;
    quantity = isIncrement ? quantity + 1 : quantity - 1;
    quantityInput.value = quantity < 0 ? 0 : quantity;
    updateAllQuantityIndicators();
  }

  document.querySelectorAll('.product-item .quantity-selector button').forEach(function (button) {
    button.addEventListener('click', function(event) {
      event.stopPropagation();
      const isIncrement = button.classList.contains('increase-quantity');
      adjustQuantity(button, isIncrement);
    });
  });

  document.querySelectorAll('.product-item .quantity-selector input').forEach(function (input) {
    input.addEventListener('change', function(event) {
      event.stopPropagation();
      updateAllQuantityIndicators();
    });
  });

  function filterProductsAndDivsByTag(tag) {
    document.querySelectorAll(".product-item, div[id^='head__']").forEach(function (element) {
      element.style.display = element.getAttribute("data-tags").includes(tag) ? "flex" : "none";
    });
  }

  document.querySelectorAll(".bb-tag-item").forEach(function (item) {
    item.addEventListener("click", function () {
      document.querySelectorAll('.bb-tag-item').forEach(function (navItem) {
        navItem.classList.remove('active');
      });
      item.classList.add('active');
      filterProductsAndDivsByTag(item.getAttribute("data-tag"));
    });
  });

  const tagNavigation = document.querySelector(".tag-navigation");
  let isDown = false;
  let startX;
  let scrollLeft;

  tagNavigation.addEventListener('mousedown', (e) => {
    isDown = true;
    tagNavigation.classList.add('active');
    startX = e.pageX - tagNavigation.offsetLeft;
    scrollLeft = tagNavigation.scrollLeft;
  });

  tagNavigation.addEventListener('mouseleave', () => {
    isDown = false;
    tagNavigation.classList.remove('active');
  });

  tagNavigation.addEventListener('mouseup', () => {
    isDown = false;
    tagNavigation.classList.remove('active');
  });

  tagNavigation.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tagNavigation.offsetLeft;
    const walk = (x - startX) * 3;
    tagNavigation.scrollLeft = scrollLeft - walk;
  });

  function updateArrowVisibility() {
    const tagNavigationWidth = tagNavigation.offsetWidth;
    const tagListWidth = tagNavigation.scrollWidth;
    const scrollPosition = tagNavigation.scrollLeft;

    document.querySelector('.left-arrow').style.display = scrollPosition > 0 ? 'block' : 'none';
    document.querySelector('.right-arrow').style.display = (scrollPosition + tagNavigationWidth) < tagListWidth ? 'block' : 'none';
  }

  updateArrowVisibility();
  tagNavigation.addEventListener('scroll', updateArrowVisibility);

  document.querySelector('.left-arrow').addEventListener('click', function() {
    tagNavigation.scrollLeft -= 100;
    updateArrowVisibility();
  });

  document.querySelector('.right-arrow').addEventListener('click', function() {
    const tagNavigationWidth = tagNavigation.offsetWidth;
    const tagListWidth = tagNavigation.scrollWidth;

    if (tagNavigation.scrollLeft + tagNavigationWidth >= tagListWidth) {
      tagNavigation.scrollLeft = 0;
    } else {
      tagNavigation.scrollLeft += 100;
    }
    updateArrowVisibility();
  });

  updateAllQuantityIndicators();
  // Removed auto-click of first tag to show all products by default
  // const firstTagItem = document.querySelector(".bb-tag-item");
  // if (firstTagItem) {
  //   firstTagItem.click();
  // }
});